import { FC, lazy } from "react";
import { Route, Routes } from "react-router-dom"
import Chat from "../../src/pages/chat"
import ChatUser from "../../src/pages/chat_user"
import Favorite from "../../src/pages/favorite"
import Fid from "../../src/pages/fid"
import Profile from "../../src/pages/profile"
import Subscribers from "../../src/pages/subscribers"
import FeedMap from "../components/feed-map"
import FeedPage from "../components/feed_page"
import Layout from "../components/layout/layout"
import useResize from "../hooks/useResize"
import MyEvents from "../pages/myEvents"
import InvitedEventList from "../pages/profile/inivited_event_list"
import MyEventList from "../pages/profile/my_event_list"
import ProfileSettings from "../pages/profile/profile_settings"
import PromotionEventList from "../pages/profile/promotion_event_list"
import WillGoEventList from "../pages/profile/will_go_event_list"
import Promotion from "../pages/promotion"
import CashiersDetails from "../pages/promotion/CashiersDetails"
import CashiersPage from "../pages/promotion/CashiersPage"
import EventDetailsPage from "../pages/promotion/EventDetailsPage"
import PromoTable from "../pages/promotion/EventsPage/PromoTable"
import PromoutersDetails from "../pages/promotion/PromoutersDetails"
import PromoutersPage from "../pages/promotion/PromoutersPage"
import ServerError from "../pages/serverError"
import ServiceError from "../pages/serviceError"
import WebChat from "../pages/web_chat"
import DeleteAccount from "@/pages/delete_account"
import EventEditing from "@pages/eventEditing/index.tsx"
import AboutPage from "@pages/about/AboutPage"
import CategoryPage from "@pages/category/CategoryPage"
import { ChatMode } from "@/types"
import { ProtectedRoute } from "./ProtectedRoute"
import { ProtectedRouteOrganizer } from "./ProtectedRouteOrganizer"
import { ProtectedRoutePromoterCashier } from "./ProtectedRoutePromoterCashier"
import ElementWrapper from "@/routes/ElementWrapper";
import {
  ConsentToPersonalDataProcessing,
  DocumentLayout,
  PersonalDataProcessingPolicy,
  PrivacyPolicy,
  UserAgreement
} from "@pages/documents";

export const AppRouters: FC = () => {
  const widthScreen = useResize()

  return (
    <Routes>
      <Route path={"/"} element={<Layout />}>
        <Route path="/" element={<Fid />}>
          <Route index element={<FeedPage />} />
          <Route path="map" element={<FeedMap />} />
        </Route>
        <Route path={"fid/:id"} element={<ElementWrapper />} />
        <Route path={"fid/all/:name"} element={<ElementWrapper />} />
        <Route path={"fid/:id/editing"} element={<ProtectedRoute redirect={"/"}><EventEditing /></ProtectedRoute>} />

        <Route path={"about"} element={<AboutPage />} />
        <Route path={"category/:slug"} element={<CategoryPage />} />
        <Route path={"moscow"} element={<CategoryPage city="moscow" />} />
        <Route path={"spb"} element={<CategoryPage city="spb" />} />
        <Route path={"ekb"} element={<CategoryPage city="ekb" />} />
        <Route path={"novosibirsk"} element={<CategoryPage city="novosibirsk" />} />
        <Route path={"kazan"} element={<CategoryPage city="kazan" />} />
        <Route path={"krasnodar"} element={<CategoryPage city="krasnodar" />} />
        <Route path={"rostov"} element={<CategoryPage city="rostov" />} />
        <Route path={"kaliningrad"} element={<CategoryPage city="kaliningrad" />} />

        <Route
          path="profile/promotion"
          element={
            <ProtectedRouteOrganizer redirect={"/"}>
              <Promotion />
            </ProtectedRouteOrganizer>
          }
        >
          <Route index element={<PromoTable />} />
          <Route path={"events"} element={<PromoTable />} />
          <Route path={"events/:cardId"} element={<EventDetailsPage />} />
          <Route
            path={"events/:cardId/promotes"}
            element={<PromoutersDetails />}
          />
          <Route
            path={"events/:cardId/cashiers"}
            element={<CashiersDetails />}
          />
          <Route path={"promotes"} element={<PromoutersPage />} />
          <Route path={"cashier"} element={<CashiersPage />} />
        </Route>

        <Route
          path={"favorites"}
          element={
            <ProtectedRoute redirect={"/"}>
              <Favorite />
            </ProtectedRoute>
          }
        />

        {widthScreen <= 640 ? (
          <>
            <Route
              path={"/chat"}
              element={
                <ProtectedRoute redirect={"/"}>
                  <Chat />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/chat/:id"}
              element={<ChatUser mode={ChatMode.Mobile} />}
            />
          </>
        ) : (
          <Route
            path={"/chat"}
            element={
              <ProtectedRoute redirect={"/"}>
                <WebChat />
              </ProtectedRoute>
            }
          >
            <Route
              path={"/chat/:id"}
              element={<ChatUser mode={ChatMode.Web} />}
            />
          </Route>
        )}
        <Route
          path={"profile"}
          element={
            <ProtectedRoute redirect={"/"}>
              <Profile />
            </ProtectedRoute>
          }
        >
          <Route path={"myevents"} element={<MyEventList />} />
          <Route path={"invites"} element={<InvitedEventList />} />
          <Route path={"iwillgo"} element={<WillGoEventList />} />
          <Route
            path={"tribepromotion"}
            element={
              <ProtectedRoutePromoterCashier redirect={"/profile"}>
                <PromotionEventList />
              </ProtectedRoutePromoterCashier>
            }
          />

          <Route path="map" element={<FeedMap />} />
        </Route>
        <Route
          path="profile/settings"
          element={
            <ProtectedRoute redirect={"/"}>
              <ProfileSettings value="" onChange={() => {}} />
            </ProtectedRoute>
          }
        />
        <Route
          path={"subscribers"}
          element={
            <ProtectedRoute redirect={"/"}>
              <Subscribers />
            </ProtectedRoute>
          }
        />
        <Route
          path={"my-events"}
          element={
            <ProtectedRoute redirect={"/"}>
              <MyEvents />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path={"delete-account"} element={<DeleteAccount />} />
      <Route path={"service-error"} element={<ServiceError />} />
      <Route path={"*"} element={<ServerError />} />
      <Route path={"documents"} element={<DocumentLayout/>}>
        <Route index element={<PrivacyPolicy />} />
        <Route path={"personal-data-processing-policy"} element={<PersonalDataProcessingPolicy />} />
        <Route path={"consent-to-personal-data-processing"} element={<ConsentToPersonalDataProcessing />} />
        <Route path={"user-agreement"} element={<UserAgreement />} />
      </Route>
    </Routes>
  )
}
